import { MouseEvent, PropsWithChildren, useState } from "react";
import { Popover } from "@mui/material";
import { Help } from "@mui/icons-material";

import { Button } from "@dzambalaorg/ui-kit";

import { Root, StyledWrapper } from "./styled";

export interface IInfoPopoverProps {
  className?: string;
}

export const InfoPopover = (props: PropsWithChildren<IInfoPopoverProps>) => {
  const { children } = props;
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    return false;
  };

  const handleClose = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "info" : undefined;

  return (
    <Root>
      <Button intent="icon" aria-describedby={id} onClick={handleClick}>
        <Help />
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <StyledWrapper>{children}</StyledWrapper>
      </Popover>
    </Root>
  );
};
